// extracted by mini-css-extract-plugin
module.exports = {"galleryWrapper":"VerticalVideoGallery_galleryWrapper__A6QBW","gallery":"VerticalVideoGallery_gallery__W7Vc6","galleryItem":"VerticalVideoGallery_galleryItem__wQHAW"};